import React from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import styled from "styled-components";
import { Stack } from "@mui/material";

const TooltipContainer = styled.div`
    background-color: ${({ theme }) => theme.palette.background.tooltip};
    padding: 0.5rem;
    min-width: 10rem;
    align-items: center;
    flex-direction: column;
    border-radius: 6px;
`;

const TooltipContent = styled.p`
    font-size: 12px;
    margin: 0;
    color: ${({ color }) => color};
`;

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <TooltipContainer role="status" aria-live="assertive">
                {payload.map((entry) => (
                    <Stack direction="row" spacing={0.5}>
                        <TooltipContent color={entry.color}>{`${entry.name}`} : </TooltipContent>
                        <TooltipContent> {entry.value} lines last week</TooltipContent>
                    </Stack>
                ))}
            </TooltipContainer>
        );
    }
    return null;
};

const UpskillingChart = ({ data }) => {
    if (!data) return null;
    const upskillingChartData = [
        {
            expectedTotal: data.expectedTotal,
            newTotal: data.newTotal,
        },
    ];

    return (
        <ResponsiveContainer width="95%" height="40%">
            <BarChart
                accessibilityLayer
                layout="vertical"
                stackOffset="expand"
                width={150}
                height={40}
                data={upskillingChartData}
            >
                <CartesianGrid strokeDasharray="3 3" opacity={0.2} horizontal />
                <XAxis type="number" hide />
                <YAxis type="category" dataKey="expectedTotal" hide />
                <Tooltip cursor={{ opacity: "0.2" }} content={CustomTooltip} />
                <Bar
                    dataKey="expectedTotal"
                    name="Expected Languages"
                    fill="#8884d8"
                    stackId="a"
                    maxBarSize={25}
                />
                <Bar
                    dataKey="newTotal"
                    name="New Languages"
                    fill="#82ca9d"
                    stackId="a"
                    maxBarSize={25}
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default UpskillingChart;
